module.exports = __webpack_public_path__ + "img/store-shipping.6b93cc9f.png";